import { ConfigCommonHeader } from '@net7/boilerplate-common';

export default {
  logo: {
    title: 'Aitia',
    anchor: {
      href: 'https://www.aitiasource.org/',
    },
  },
  nav: {
    items: [],
  },
} as ConfigCommonHeader;
